import { Box } from "@mui/material";
import { useListContext, useRecordContext } from "react-admin";
import ApproveConfirmModal from "./ApproveConfirmModal";
import DeclineReasonModal from "./DeclineReasonModal";

const RowApprovalActions = ({ stage }) => {
  const record = useRecordContext();
  const { resource } = useListContext();
  if (!record) return null;
  const ids = [record.id];

  return (
    <Box sx={{ display: "flex", gap: 0.5 }}>
      <ApproveConfirmModal
        stage={stage}
        ids={ids}
        resource={resource}
        triggerLabel="Одобри"
        iconOnly
      />
      <DeclineReasonModal
        stage={stage}
        ids={ids}
        resource={resource}
        triggerLabel="Отхвърли"
        iconOnly
      />
    </Box>
  );
};

export default RowApprovalActions;
